export {DealFreezeEducationBanner} from './DealFreezeEducationBanner'
export {DealFreezeEducationBannerProvider} from './DealFreezeEducationBannerProvider'
